module.exports = __webpack_public_path__ + "img/Group 2.8f24ba09.png";